import { createSelector } from 'redux-orm';

import orm from '../orm';

export const makeProtocolsSelector = () =>
  createSelector(orm, ({ Protocol }) => Protocol.getOrderedQuerySet().toRefArray());

export const protocolsSelector = makeProtocolsSelector();
